<template>
  <div class="fans-data-wrap">
    <div class="mod-tit">
      <template v-if="hasShowAllPerm">
        {{ $t('data.descAll') }}
      </template>
      <template v-else>
        {{ $t('data.descTME') }}
      </template>

      <br>
      {{ $t('data.descAppend') }}
    </div>
    <section class="total-mod-wrap">
      <div class="total-mod">
        <div class="total-mod-tit">{{ $t('data.fans.total') }}</div>
        <div class="total-mod-content">
          <span class="total-mod-count">{{ historyTotal }}</span>
          人
        </div>
      </div>
      <div class="total-mod">
        <div class="total-mod-tit">{{ $t('data.fans.yesterday') }}</div>
        <div class="total-mod-content">
          <span class="total-mod-count">{{ yesterdayTotal }}</span>
          人
        </div>
      </div>
    </section>
    <section class="chart-mod-wrap">
      <div class="chart-mod">
        <div class="chart-mod-tit">{{ $t('data.fans.terminal') }}</div>
        <front-pie-chart class="chart-mod-content" :chart-height="400" :chart-data="frontPieChartData"></front-pie-chart>
      </div>
      <div class="chart-mod">
        <div class="chart-mod-tit">{{ $t('data.fans.gender') }}</div>
        <sex-pie-chart class="chart-mod-content" :chart-height="400" :chart-data="sexPieChartData"></sex-pie-chart>
      </div>
      <div class="chart-mod">
        <div class="chart-mod-tit">{{ $t('data.fans.area') }}</div>
        <map-chart class="chart-mod-content" :chart-height="400" :chart-data="mapChartData"></map-chart>
      </div>
      <div class="chart-mod">
        <div class="chart-mod-tit">{{ $t('data.fans.top') }}</div>
        <bar-chart class="chart-mod-content" :chart-height="400" :chart-data="barChartData"></bar-chart>
      </div>
    </section>
  </div>
</template>

<script>
import FrontPieChart from './components/FrontPieChart'
import SexPieChart from './components/SexPieChart'
import MapChart from './components/MapChart'
import BarChart from './components/BarChart'
import dataService from '@/api/data'
import { formatNum } from '@/utils/strUtil'
import pageMixin from './mixin/pageMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'DataFans',
  components: {
    FrontPieChart,
    SexPieChart,
    MapChart,
    BarChart
  },
  mixins: [pageMixin],
  data() {
    return {
      historyTotal: 0,
      yesterdayTotal: 0,
      frontPieChartData: [],
      sexPieChartData: [],
      mapChartData: [],
      barChartData: []
    }
  },
  computed: {
    ...mapGetters(['hasShowAllPerm'])
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      return dataService.getUsersData().then(res => {
        this.historyTotal = formatNum(res.historyTotal || 0)
        this.yesterdayTotal = formatNum(res.yesterdayTotal || 0)
        this.frontPieChartData = res.machine.map(item => {
          item.name = this.$t(`data.fans.${item.name}`)

          return item
        })
        this.sexPieChartData = res.sex.map(item => {
          item.name = this.$t(`data.fans.${item.name}`)

          return item
        })
        this.mapChartData = res.provinces
        this.barChartData = res.city.reverse()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.fans-data-wrap {
  padding: 0 10px 10px;

  .mod-tit {
    margin: -10px 0 20px;
    color: #999;
  }
}
.total-mod {
  flex: 1;
  padding: 20px;
  margin: 15px 10px 5px;
  font-size: 18px;
  color: #666;

  &-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: #fff;
  }

  &:last-child {
    margin-right: 0;
  }

  &-tit {
    font-weight: bold;
    color: #333;
  }

  &-content {
    margin-top: 10px;
  }

  &-count {
    font-size: 34px;
    font-weight: bold;
    color: #333;
  }
}

.chart-mod {
  flex: 0 0 49%;
  background: #fff;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;

  &-wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  &-tit {
    margin: 20px 20px 0;
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
}
</style>
